module.exports = __webpack_public_path__ + "img/honor5.f90a4332.jpg";